// extracted by mini-css-extract-plugin
export default {"available":"availabilityStatus_available__yfpJt","unavailable":"availabilityStatus_unavailable__qg51z"};